import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store/index";
import VueCookies from "vue-cookies";
import website from "@/config/website";
import { Base64 } from "js-base64";
import { setCookie,delCookieInfos } from "@/utils/util.js";

var HttpRequest = {
  getRequest({ url, data = {}, method = "GET", header, onUploadProgress}) {
    console.log(header, 'headerheader')
    return new Promise((resolve, reject) => {
      this._getRequest(url, resolve, reject, data, method, header, onUploadProgress);
    });
  },

  _getRequest: function (url, resolve, reject, data = {}, method = "GET", header, onUploadProgress) {
    var token = VueCookies.get("userToken");
    var RoleId = VueCookies.get("Role-Id");
    var userInfo = localStorage.getItem('UserInfo')

    console.log(userInfo, 'userInfouserInfo')
    let format =
      method.toLocaleLowerCase() === "get" ||
        method.toLocaleLowerCase() === "delete" ?
        "params" :
        "data";

    axios.defaults.headers.common = {
      Authorization: `Basic ${Base64.encode(
        `${website.clientId}:${website.clientSecret}`
      )}`,
      "Wenbo-Auth": "bearer " + token,
      "Tenant-Id": VueCookies.get("tenantId"),
      // "Role-Id": RoleId || undefined,
      "Content-Type": "application/json; charset=UTF-8",
      "Client-Type": "WenboSaber"
    };

    const Connection = process.env.URL_CONNECTION;
    console.log(Connection, 'ConnectionConnection')
    // const instance = axios.create({
    //   baseURL: Connection,
    // });

    // axios.get(
    //   Connection + "/wenbo-auth/oauth/wbtoken?grant_type=refresh_token&refresh_token=" + 'bearer ' + token,
    // ).then(res => {
    //   console.log(res, 'tokentoken')
    // })
    axios({
      // url: Connection + url,
      url:url,
      async: false,
      method: method,
      [format]: data,
      onUploadProgress: onUploadProgress
    }).then(res => {
      // var token = VueCookies.get("userToken");
      // axios({
      //   url: Connection + "/wenbo-auth/oauth/wbtoken",
      //   method: 'get',
      //   params: {
      //     grant_type: 'refresh_token',
      //     refresh_token: 'bearer ' + token
      //   }
      // }).then(res => {
      //   console.log(res, 'tokentoken')
      // })
      console.log(res, "http-errorddd")

      if (res.data.code == 200) {
        resolve(res.data);
      } else if (res.data.code == 9998) {
        Message({
          message: "您尚未登录，请先登录",
          type: "error",
          duration: 1000
        });
        // VueCookies.set("userToken", null);
        setCookie("userToken", null);
        delCookieInfos();
        setTimeout(() => {
          window.location.href = process.env.LOGINIURL;
        }, 1000);
        resolve(res);
      } else if (res.data.code == 9999) {
        Message({
          message: "登录已过期，请重新登录",
          type: "error",
          duration: 1000
        });
        // VueCookies.set("userToken", null);
        setCookie("userToken", null);
        delCookieInfos();
        setTimeout(() => {
          window.location.href = process.env.LOGINIURL;
        }, 1000);
        resolve(res);
      } else if (res.data.code == 500) {
        Message({
          message: res.data.msg,
          type: "error",
          duration: 1000
        });
        reject(error)
      } else {
        console.log(res.data, '进入 了')
        Message.error(res.data.msg);
      }
    })
      .catch((res) => {
        // console.log(res, "http-error")
        // // Message.error(error);
        // reject(res)
        Message({
          message: "未知错误",
          type: "error",
          duration: 1000
        });
      });
  }
};
export { HttpRequest };


// WEBPACK FOOTER //
// ./src/request/http.js